export class AssemblyInterfacesTranslate {
    constructor(data) {
        this.interfaceMap = new Map();
        this.rawData = data;
        data.forEach(d => {
            this.interfaceMap.set(d.rcsbId, d.interfaceIds);
        });
    }
    getInterfaces(assemblyId) {
        return this.interfaceMap.get(assemblyId);
    }
    getRawData() {
        return this.rawData;
    }
}
//# sourceMappingURL=AssemblyInterfacesTranslate.js.map